import React from 'react';
import { Content } from 'components';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'Redux/store';
import './styles/main.scss';

export const DEFAULT_REACT_APP_CF_SCENARIO_PLAYING_AND_DRIVERS_OF_GROWTH =
    'https://europe-west2-stratsims-appothecary.cloudfunctions.net/dev-populationprojection-us-plot-function-2nd-gen/';

export const DEFAULT_REACT_APP_CF_CORE_LEARNING_SCREENS =
    'https://oppsim-us-core-learning-screens-dev-osveracymq-nw.a.run.app';

export const BASE_REACT_APP_CF_SCENARIO_PLAYING_AND_DRIVERS_OF_GROWTH =
    import.meta.env.VITE_REACT_APP_CF_SCENARIO_PLAYING_AND_DRIVERS_OF_GROWTH ||
    DEFAULT_REACT_APP_CF_SCENARIO_PLAYING_AND_DRIVERS_OF_GROWTH;

export const BASE_REACT_APP_CF_CORE_LEARNING_SCREENS =
    import.meta.env.VITE_REACT_APP_CF_CORE_LEARNING_SCREENS ||
    DEFAULT_REACT_APP_CF_CORE_LEARNING_SCREENS;

export const V3AssetPathContext = React.createContext({ isV3: false, assetPath: '' });

interface AppProps {
    baseUrl: string;
    isV3?: boolean;
    assestPath?: string;
}

export const App = (props: AppProps) => {
    return (
        <BrowserRouter basename={props.baseUrl}>
            <Provider store={store}>
                <V3AssetPathContext.Provider
                    value={{
                        isV3: props.isV3 ? true : false,
                        assetPath: props.assestPath ? props.assestPath : '',
                    }}
                >
                    <div id="">
                        <Content />
                    </div>
                </V3AssetPathContext.Provider>
            </Provider>
        </BrowserRouter>
    );
};
